@switch (content()) {
  @case ("tiers") {
    <div class="tier-first-overlay" [class.shows-app-background]="showsAppBackground()">
      <div class="tier-first-content">
        <app-wager-tier-list
          [allTiers]="allTiersSignal()"
          [freeMatches]="freeMatchesSignal()"
          [currentTournamentData]="currentTournamentDataSignal()"
          [soloTiers]="soloTiersSignal()"
          [waitingOpponentsStandard]="waitingOpponentsStandard()"
          [paymentInFlight]="paymentInFlight()"
          [userBalance]="userBalance()"
          [formattedBalance]="formattedBalance()"
          [canShowLocal]="canShowLocal()"
          [isMarbles]="isMarbles()"
          (wagerClickEvent)="onWagerClick($event)"
          (tournamentPlayClickEvent)="onTournamentPlayClick($event)"
          (tutorialRequestedEvent)="onTutorialRequested($event)"
          (leaderboardRequestedEvent)="onLeaderboardRequested($event)"
          (freeMatchClickEvent)="onFreeMatchClick($event)"
          (soloClickEvent)="onSoloClick()"
          (practiceClickEvent)="onPracticeClick()"
          (localClickEvent)="onLocalClick()"
          (celebrationClearedEvent)="onCelebrationCleared()"
        />
      </div>
    </div>
  }
  @case ("continue-game") {
    <div class="continue-game-footer">
      <app-countdown-pill
        class="time-remaining"
        [timeRemaining]="unfinishedTimeRemaining()"
        size="small"
      />
      <app-button
        [label]="continueButtonLabel()"
        variant="primary"
        stretch="fill"
        (clickEvent)="continueGameClicked()"
      />
    </div>
  }
}
